import { render, staticRenderFns } from "./DocumentTags.vue?vue&type=template&id=6f7c03f8"
import script from "./DocumentTags.vue?vue&type=script&lang=js"
export * from "./DocumentTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3343509444/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f7c03f8')) {
      api.createRecord('6f7c03f8', component.options)
    } else {
      api.reload('6f7c03f8', component.options)
    }
    module.hot.accept("./DocumentTags.vue?vue&type=template&id=6f7c03f8", function () {
      api.rerender('6f7c03f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DocumentTags.vue"
export default component.exports